<template>
    <div v-if="FilterBlock.hidden === false" class="filter-block">
        <div class="filter-block__header"
             :class="{ 'filter-block__header--open' : toggleFilter }"
             @click="toggleFilter = !toggleFilter">
            <h4>{{ FilterBlock.label }}</h4>
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" fill="none">
                <path fill="#282A29" fill-rule="evenodd"
                      d="M6.82361 8c-.256 0-.50094-.10424-.67836-.28894L.262861 1.5936C-.0976118 1.21901-.085847.623009.288979.262771.66357-.097467 1.25934-.0859375 1.61958.288889L6.82361 5.70093 12.0276.288889c.36-.3745912.9558-.386356 1.3306-.026118.3749.360238.3866.956239.0262 1.330829L7.50197 7.71106C7.32456 7.89576 7.07961 8 6.82361 8"
                      clip-rule="evenodd"/>
            </svg>
        </div>
        <div class="filter-block__components" :class="{ 'filter-block__components--open' : toggleFilter }">
            <filter-block-checkbox-group v-if="FilterBlock.type === 'checkbox'" v-model:value="category"
                                         :options="options"></filter-block-checkbox-group>
            <filter-block-select v-if="FilterBlock.type === 'select'" v-model:value="category"
                                 :options="options"></filter-block-select>
            <filter-block-radio-group v-if="FilterBlock.type === 'radio'" v-model:value="category"
                                      :name="FilterBlock.label" :options="options"></filter-block-radio-group>
        </div>
    </div>
</template>

<script>

import FilterBlockCheckboxGroup from "./FilterBlockCheckboxGroup";
import FilterBlockSelect from "./FilterBlockSelect";
import FilterBlockRadioGroup from "./FilterBlockRadioGroup";
import {onMounted, ref} from "vue";
import axios from "axios";
import {useStore} from 'vuex';

export default {
    props: ['FilterBlock'],
    name: "",

    data() {
        return {
            toggleFilter: true
        }
    },

    setup(props) {
        const store = useStore();
        let category = ref([]);
        let options = ref([]);

        const getCategory = () => {
            category.value = [];
        };

        const getCategoryData = async () => {

            let taxUrl = store.state.baseUrl;
            taxUrl += '/wp-json/wp/v2/';
            taxUrl += props.FilterBlock.value;


            await axios.get(taxUrl).then(response => {
                options.value = response.data;

                //Add 'All' option if type is radio
                if (props.FilterBlock.type === 'radio') {
                    let allObj = {
                        id: 0,
                        count: 0,
                        link: '',
                        name: 'All',
                        slug: ''
                    }
                    options.value.unshift(allObj)
                }
            });
        };

        onMounted(() => {
            getCategoryData();
            getCategory();
        });

        return {
            category,
            options,
        };
    },
    watch: {
        category: function (newVal, oldVal) { // watch it
            let filterData = {
                tax_name: this.FilterBlock.label,
                tax: this.FilterBlock.value,
                values: newVal
            };

            this.$store.commit('fetchFilterData', filterData);
            if (this.$store.state.initialPageLoad === false) {
                this.$store.commit('triggerCount');
            }
            this.$store.commit('setFilterState');
        }
    },
    components: {
        "filter-block-checkbox-group": FilterBlockCheckboxGroup,
        "filter-block-select": FilterBlockSelect,
        "filter-block-radio-group": FilterBlockRadioGroup
    },
};
</script>
